<template>
  <div class="pass-progress">
    <div class="pass-progress__bar-wrapper">
      <div class="pass-progress__bar" :class="barColor" :style="{ width: barWidth }"></div>
    </div>

    <div :class="['pass-progress__message', textColor]">
      {{ strengthMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    password: string;
  }>();

  const { getContent } = useProjectMethods();
  const globalStore = useGlobalStore();
  const { fieldsSettings, defaultLocaleFieldsSettings } = storeToRefs(globalStore);

  const strengthMessage = computed(() => {
    if (props.password.length < 8) {
      return getContent(
        fieldsSettings.value,
        defaultLocaleFieldsSettings.value,
        'validationMessages.atLeastCharacters'
      );
    }

    if (/^\d+$/.test(props.password) || /^[a-zA-Z]+$/.test(props.password)) {
      return getContent(fieldsSettings.value, defaultLocaleFieldsSettings.value, 'validationMessages.weakPassword');
    }

    return getContent(fieldsSettings.value, defaultLocaleFieldsSettings.value, 'validationMessages.strongPassword');
  });

  const barColor = computed(() => {
    if (props.password.length < 8) return 'pass-progress__bar--red';
    if (/^\d+$/.test(props.password) || /^[a-zA-Z]+$/.test(props.password)) return 'pass-progress__bar--orange';
    return 'pass-progress__bar--green';
  });

  const barWidth = computed(() => {
    if (props.password.length < 1) return '0%';
    if (props.password.length < 8) return '14%';
    if (/^\d+$/.test(props.password) || /^[a-zA-Z]+$/.test(props.password)) return '60%';
    return '100%';
  });

  const textColor = computed(() => {
    if (props.password.length < 8) return 'pass-progress__message--red';
    if (/^\d+$/.test(props.password) || /^[a-zA-Z]+$/.test(props.password)) return 'pass-progress__message--orange';
    return 'pass-progress__message--green';
  });
</script>

<style src="~/assets/styles/components/atomic/pass-progress.scss" lang="scss" />
